/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Bom_Dialog_HintInputs */

const vi_packaging_bom_dialog_hint = /** @type {(inputs: Packaging_Bom_Dialog_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khai báo mỗi loại bao bì tốn bao nhiêu cho một sản phẩm. Kho dựa vào đây để trừ hàng khi đóng gói.`)
};

/**

* @param {Packaging_Bom_Dialog_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_bom_dialog_hint = /** @type {((inputs?: Packaging_Bom_Dialog_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Bom_Dialog_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_bom_dialog_hint(inputs)
});